import React, { FC, useEffect, useState } from "react"
import Loading from "../../../../ui/Loading"
import { KSpan, KInput, KButton } from "kahuna-base-react-components"
import { crawlers } from "../../../../../apis"
import { ReleaseTakedownLog, TakedownLog } from "../../../../../types"
import { mapListToCamelCase } from "../../../../../utility"
//@ts-ignore
import CheckIcon from "../../../../../assets/admin_icons/check-circle.svg"
//@ts-ignore
import CheckRedIcon from "../../../../../assets/admin_icons/check-circle-red.svg"
//@ts-ignore
import CloseIcon from "../../../../../assets/admin_icons/close-circle.svg"
//@ts-ignore
import CloseGreenIcon from "../../../../../assets/admin_icons/close-circle-green.svg"
//@ts-ignore
import AppleMusicIcon from "../../../../../assets/release-platform-icons/Apple-Music.png"
// @ts-ignore
import YoutubeLogo from "../../../../../assets/logo-icons/youtube-logo.png"

import { connect } from "react-redux"
import { RootState } from "../../../../../store"
import { toast } from "react-toastify"

const releaseColumnWidths: any = {
  ID: "4%",
  RELEASE: "43%",
  STATUS: "10%",
  SPOTIFY: "15%",
  APPLE: "15%",
  YOUTUBE: "13%"
}

type AdminTakedownLogProps = {
  takedownLog: TakedownLog
}

const AdminTakedownLog: FC<AdminTakedownLogProps> = (props) => {
  const [loading, setLoading] = useState(false)
  const [releaseTakedownLogList, setReleaseTakedownLogList] = useState<ReleaseTakedownLog[]>([])
  const [filteredReleaseTakedownLogList, setFilteredReleaseTakedownLogList] = useState<ReleaseTakedownLog[]>([])
  const [searchText, setSearchText] = useState("")

  const fetchReleaseTakedownLogList = () => {
    setLoading(true)
    crawlers(`/takedown-logs/release_takedown_logs/?takedown_log_id=${props.takedownLog.id}`, "GET").then((resp) => {
      setReleaseTakedownLogList(mapListToCamelCase(resp.data.results))
      setFilteredReleaseTakedownLogList(mapListToCamelCase(resp.data.results))
      setLoading(false)
    })
  }

  const openYoutubePlatform = (releaseLog: ReleaseTakedownLog) => {
    if (!releaseLog.release) {
      return
    }
    crawlers(`/takedown-logs/release_isrc_list/?release_id=${releaseLog.release.id}`, "GET").then((resp) => {
      const isrcList: string[] = resp.data.results
      if (isrcList.length === 0) {
        toast.info("No ISRCs found for this release")
        return
      }
      window.open(`https://www.youtube.com/results?search_query=%22${isrcList[0]}%22`, "_blank")
    })
  }

  useEffect(() => {
    if (!props.takedownLog) return
    fetchReleaseTakedownLogList()
  }, [props.takedownLog])

  const renderBoolean = (value?: boolean, isReverse?: boolean) => {
    const icon = isReverse ? (value ? CheckRedIcon : CloseGreenIcon) : value ? CheckIcon : CloseIcon
    return <img className="min-w-5 max-w-5 min-h-5 max-h-5" src={icon} alt="status-icon" />
  }

  const openMultiPlatform = (platformUrl?: string, platformIds?: string) => {
    if (!platformUrl || !platformIds) return
    platformIds.split(",").forEach((id) => {
      window.open(`${platformUrl}${id}`, "_blank")
    })
  }

  const onCopy = () => {
    const options = ["1", "2", "3", "4", "5", "6", "7", "8"]
    const copyType = window.prompt(
      "Choose from options below: \n\n1 - All complete\n2 - Spotify complete\n3 - Apple complete\n4 - Youtube complete\n5 - Not complete\n6 - Spotify not complete\n7 - Apple not complete\n8 - Youtube not complete"
    )

    if (!copyType || !options.includes(copyType)) {
      toast.error("Invalid option. Choice must be a number between 1 and 8.")
      return
    }

    navigator.clipboard.writeText(
      filteredReleaseTakedownLogList
        .map((log) => {
          switch (copyType) {
            case "1":
              return log.spotifyComplete && log.appleComplete && log.youtubeComplete ? log.release?.upc : null
            case "2":
              return log.spotifyComplete ? log.release?.upc : null
            case "3":
              return log.appleComplete ? log.release?.upc : null
            case "4":
              return log.youtubeComplete ? log.release?.upc : null
            case "5":
              return !log.spotifyComplete || !log.appleComplete || !log.youtubeComplete ? log.release?.upc : null
            case "6":
              return !log.spotifyComplete ? log.release?.upc : null
            case "7":
              return !log.appleComplete ? log.release?.upc : null
            case "8":
              return !log.youtubeComplete ? log.release?.upc : null
            default:
              return null
          }
        })
        .filter((upc) => upc !== null)
        .join(",")
    )
    toast.success("Copied to clipboard.")
  }

  const onSearch = (text: string) => {
    setSearchText(text)

    if (!text) {
      setFilteredReleaseTakedownLogList(releaseTakedownLogList)
      return
    }

    const filteredReleaseTakedownLogList = releaseTakedownLogList.filter((releaseTakedownLog: ReleaseTakedownLog) => {
      if (releaseTakedownLog.release?.title.includes(text) || releaseTakedownLog.release?.upc === text) {
        return true
      } else {
        return false
      }
    })
    setFilteredReleaseTakedownLogList(filteredReleaseTakedownLogList)
  }

  const renderPlatformBlock = (
    platformUrl?: string,
    platformIds?: string,
    visible?: boolean,
    complete?: boolean,
    linkCount?: number,
    extra?: React.ReactNode
  ) => {
    return (
      <div className="flex flex-col gap-1">
        <div className="flex gap-10">
          <KSpan text="Links:" />
          <div
            className={platformUrl ? "cursor-pointer" : ""}
            onClick={() => openMultiPlatform(platformUrl, platformIds)}
          >
            <KSpan text={linkCount?.toString() || "0"} />
          </div>
        </div>
        <div className="flex gap-6">
          <KSpan text="Visible:" />
          {renderBoolean(visible, false)}
        </div>
        <div className="flex gap-1">
          <KSpan text="Complete:" />
          {renderBoolean(complete, false)}
        </div>
        {extra}
      </div>
    )
  }

  const renderReleaseTakedownLogs = () => {
    return (
      <div className="pt-4 pb-4 flex flex-col">
        <div className="mb-6 flex justify-between">
          <KButton width="160px" text="Copy UPC list" onClick={() => onCopy()} background="black" textColor="white" />
          <KInput
            width={220}
            onChange={(text) => onSearch(text)}
            value={searchText}
            placeholder="Search release title or upc"
          />
        </div>
        {/* Header */}
        <div className="flex pb-2 gap-2">
          {Object.keys(releaseColumnWidths).map((header) => (
            <div key={`release_header_${header}`} style={{ width: releaseColumnWidths[header] }}>
              <KSpan fontWeight={600} text={header} />
            </div>
          ))}
        </div>

        {/* Rows */}
        {filteredReleaseTakedownLogList.map((releaseLog) => (
          <div key={`release_log_${releaseLog.id}`} className="pt-2" style={{ borderTop: "1px dashed grey" }}>
            <div className="flex gap-2 mb-2">
              {/* ID */}
              <div style={{ width: releaseColumnWidths.ID }}>
                <KSpan text={releaseLog.id?.toString() || "-"} />
              </div>

              {/* RELEASE */}
              <div style={{ width: releaseColumnWidths.RELEASE }}>
                <div className="flex gap-4">
                  <div>
                    <img src={releaseLog.release?.coverFileUrl} width={95} height={95} style={{ borderRadius: 5 }} />
                  </div>
                  <div className="flex flex-col gap-1">
                    <div className="flex gap-1">
                      <KSpan text={`${releaseLog.release?.title || "-"}`} fontWeight={500} />
                      {releaseLog.release?.version && <KSpan text={`(${releaseLog.release?.version || ""})`} />}
                    </div>
                    <KSpan text={`UPC: ${releaseLog.release?.upc || "-"}`} />
                    <div className="flex gap-2 mt-1">
                      <img
                        className="cursor-pointer"
                        onClick={() => {
                          if (!releaseLog.spotifyId) return
                          window.open(`https://open.spotify.com/album/${releaseLog.spotifyId}`, "_blank")
                        }}
                        src={"/account_icons/social_media_icons/spotify.svg"}
                        alt={`${releaseLog.id}_spotify_link`}
                        style={{ width: 24, height: 24, minWidth: 24, minHeight: 24, cursor: "pointer" }}
                      />
                      <img
                        onClick={() => {
                          if (!releaseLog.appleId) return
                          window.open(`https://music.apple.com/us/album/${releaseLog.appleId}`, "_blank")
                        }}
                        src={AppleMusicIcon}
                        alt={`${releaseLog.id}_spotify_link`}
                        style={{ width: 24, height: 24, minWidth: 24, minHeight: 24, cursor: "pointer" }}
                      />
                      <img
                        onClick={() => openYoutubePlatform(releaseLog)}
                        src={YoutubeLogo}
                        alt={`${releaseLog.id}_youtube_link`}
                        style={{ width: 24, height: 24, cursor: "pointer" }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* STATUS */}
              <div style={{ width: releaseColumnWidths.STATUS }}>
                <KSpan text={releaseLog.status || "-"} />
              </div>

              {/* SPOTIFY */}
              <div style={{ width: releaseColumnWidths.SPOTIFY }}>
                {renderPlatformBlock(
                  "https://open.spotify.com/album/",
                  releaseLog.linkedSpotifyIds,
                  releaseLog.spotifyVisible,
                  releaseLog.spotifyComplete,
                  releaseLog.spotifyLinkCount,
                  <div className="flex " style={{ gap: 39 }}>
                    <KSpan text="Split:" />
                    {renderBoolean(releaseLog.spotifySplitExist, true)}
                  </div>
                )}
              </div>

              {/* APPLE */}
              <div style={{ width: releaseColumnWidths.APPLE }}>
                {renderPlatformBlock(
                  `https://music.apple.com/us/album/`,
                  releaseLog.linkedAppleIds,
                  releaseLog.appleVisible,
                  releaseLog.appleComplete,
                  releaseLog.appleLinkCount
                )}
              </div>

              {/* YOUTUBE */}
              <div style={{ width: releaseColumnWidths.YOUTUBE }}>
                {renderPlatformBlock(
                  undefined,
                  undefined,
                  releaseLog.youtubeVisible,
                  releaseLog.youtubeComplete,
                  releaseLog.youtubeLinkCount
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="catalog flex flex-col bg-[#fff]">
      {loading && <Loading />}
      {renderReleaseTakedownLogs()}
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps, {})(AdminTakedownLog)
